import { TableCell, TableRow } from "@/components/ui/table";
import { Table, flexRender } from "@tanstack/react-table";
import { subscriptionOfferColumns } from "../../assets/SubscriptionOfferColumns";
import { SubscriptionOfferTable } from "../../types/subscriptions.type";

interface Props<TData> {
  table: Table<TData>;
}

export function SubscriptionOffersTableContent<
  TData extends SubscriptionOfferTable
>({ table }: Props<TData>) {
  return table.getRowModel().rows.length ? (
    table.getRowModel().rows.map((row) => (
      <TableRow
        className="h-16"
        key={row.id}
        data-testid="subscriptionOfferRow"
      >
        {row.getVisibleCells().map((cell) => (
          <TableCell className="first:w-16 last:w-10" key={cell.id}>
            {flexRender(cell.column.columnDef.cell, cell.getContext())}
          </TableCell>
        ))}
      </TableRow>
    ))
  ) : (
    <TableRow data-testid="subscriptionOffersEmpty">
      <TableCell
        colSpan={subscriptionOfferColumns.length}
        className="h-16 text-center"
      >
        No subscription offers found
      </TableCell>
    </TableRow>
  );
}
